import { paths } from '../../config';
import MainContainer from '../main-container';
import Form from './instanceForm';
import List from './instanceList';

const settings = {
    pathRegister: paths.instanceRegister,
    pathList: paths.instance,
    apiPath: 'instances',
    permissionAdmin: null,
    title: 'Instância',
};

const FormEntity: React.FC = () => {
    return (
        <MainContainer>
            <Form settings={settings} />
        </MainContainer>
    );
};

const ListEntity: React.FC = () => {
    return (
        <MainContainer>
            <List settings={{ ...settings, title: 'Instâncias' }} />
        </MainContainer>
    );
};

export { FormEntity, ListEntity };
